module.exports = __webpack_public_path__ + "img/RoutesDay.76f9fa3b.svg";